import React from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';
import CategoryItem from './CategoryItem';
import ImprovementItem from './ImprovementItem';
import CategoryItemLocked from './CategoryItemLocked';
import IsNullOrUndefined from '../../../utils/ObjectUtils';

const RoomItem = ({
 id, name, nextRoomName, categories, isFirstItem, isLastItem,
}) => (
  <Element className="room-item" id={id}>
    <div className="room-title-container">
      <div className="room-title">{name}</div>
      <div className="divider-bottom" />
    </div>
    <div className="container-categories">
      {categories.map((category, index) => (
          !IsNullOrUndefined(category.availableIf) || !IsNullOrUndefined(category.incompatibleWith)
          ? (
            <CategoryItemLocked
              category={category}
              isLastItem={isLastItem && category.id === categories[categories.length - 1].id}
            />
          )
        : (
          <CategoryItem
            category={category}
            roomId={id}
            isLastItem={isLastItem && category.id === categories[categories.length - 1].id}
            order={index}
          />
        )))}
    </div>
  </Element>
);

RoomItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  nextRoomName: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.number,
    cameras: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      roomId: PropTypes.string,
      isPriority: PropTypes.bool,
    })),
    selected_feature: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      thumb: PropTypes.string,
      order: PropTypes.number,
    })),
  })).isRequired,
  isFirstItem: PropTypes.bool.isRequired,
  isLastItem: PropTypes.bool.isRequired,
};

export default RoomItem;
